import { useState, useEffect } from "react";
// import Loader from "utils/Loader";
import axios from "axios";
// import { inventory } from "../services/transactions";

function UserName({ id, updater }) {
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [Inventory, setInventory] = useState("");
  useEffect(async () => {
    if (!isNaN(parseInt(id))) {
      setLoading(true);
      // let money = await inventory(id);
      let money = 0;
      setInventory(money);
      let form = new FormData();
      form.append("conditions", `id/=/${id}`);
      axios
        .post("http://mvc.dade24.ir/api/Find_users", form)
        .then(({ data }) => {
          setLoading(false);
          setInfo(data[0]);
        })
        .catch((error) => {});
    }
  }, [updater]);

  return (
    <div className="modal fade" id="userInfo" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      {/* {loading ? <Loader /> : ""} */}

      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              اطلاعات کاربر
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            {info && (
              <>
                {info.profilepic == "" ? null : <img className="rounded-circle w-25" src={`${"http://mvc.dade24.ir/" + info.profilepic}`} />}
                <h5>نام و نام خانوادگی :{info.fname + " " + info.lname}</h5>
                <h5>نام پدر :{info.fathername}</h5>
                <h5>کد ملی :{info.codemelli}</h5>
                <h5>شماره تماس :{info.mobile}</h5>
                <h5> موجودی کیف پول :{Inventory}</h5>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserName;
